import Vue from 'vue'
import Vuex from 'vuex'
import common from './common'
import user from './user'
import order from './order'
import repay from './repay'
import bankcard from './bankcard'
import withdraw from './withdraw'
import protocol from './protocol'
import authentication from './authentication'
import activities from './activities'
import vip from './vip'
import refund from './refund'
import apiDiversion from './api-diversion'
import wxBind from './wx-bind'
import modify from './modify'

Vue.use(Vuex)

export default new Vuex.Store({
  ...common,
  modules: {
    user,
    order,
    repay,
    bankcard,
    protocol,
    withdraw,
    authentication, 
    activities,
    vip,
    refund,
    apiDiversion,
    wxBind,
    modify
  }
})
